import TeamMemberPanel from './TeamMemberPanel';

/**
 * Fiche membre large (Gestion) — conteneur uniquement, métier dans TeamMemberPanel.
 */
export default function TeamMemberLargeDrawer({
  open,
  onClose,
  panelProps,
}) {
  if (!open || !panelProps?.member) return null;

  return (
    <>
      <button
        type="button"
        className="fixed inset-0 z-40 bg-slate-900/20"
        aria-label="Fermer la fiche membre"
        onClick={onClose}
      />
      <aside
        className="fixed inset-y-0 right-0 z-50 flex w-[min(80vw,1100px)] max-w-[calc(100vw-1rem)] flex-col border-l border-gray-100 bg-white shadow-2xl"
        aria-labelledby="team-member-drawer-title"
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-3 sm:p-4">
          <TeamMemberPanel {...panelProps} layout="drawer" onClose={onClose} />
        </div>
      </aside>
    </>
  );
}
